import { Redirect } from 'react-router-dom';
import { Dashboard } from 'components/Dashboard/Dashboard';
import { SHOW_INIT_DASHBOARD_FILTERS_KEY } from 'utils/constants';
import { ROUTE_ROOT } from 'utils/routes';

export const DashboardPage = () => {
  const dashboardFilters = localStorage.getItem(SHOW_INIT_DASHBOARD_FILTERS_KEY);
  const showDashboardFilter = dashboardFilters !== 'false';

  return showDashboardFilter ? <Dashboard /> : <Redirect exact to={ROUTE_ROOT} />;
};
